var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.11 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unlock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.89,56h9V37.12a37,37,0,0,1,10.9-26.21h0a37,37,0,0,1,52.42,0h0a37,37,0,0,1,10.9,26.21V38H71.66V36.91a22.68,22.68,0,0,0-6.66-16h0a22.69,22.69,0,0,0-38.72,16V56h67a2.9,2.9,0,0,1,2.89,2.89V120a2.9,2.9,0,0,1-2.89,2.89H2.89A2.9,2.9,0,0,1,0,120V58.93A2.9,2.9,0,0,1,2.89,56ZM49.15,89.45l4.58,21.14-12.56,0,3.69-21.42a8.51,8.51,0,1,1,4.29.23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.2f31bf2b8d3004384940d61a74ceb9e6.svg";
export { ForwardRef as ReactComponent };